export default "__VITE_ASSET__D2lfWcU5__"